import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-ios-install-dialog',
    templateUrl: './ios-install-dialog.component.html',
    styleUrls: ['./ios-install-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IosInstallDialogComponent {}
